<h2 mat-dialog-title class="dialog-title">
  <span>{{ data.title }}</span>
  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</h2>
@if (data.description) {
  <div class="subtitle">{{ data.description }}</div>
}

<mat-dialog-content class="dialog-content">
  @if (loading) {
    <mat-spinner [diameter]="40"></mat-spinner>
  } @else if (loadError) {
    <glxy-alert type="warning">
      {{ 'INBOX.CITATIONS.FUNCTION.LOAD_ERROR' | translate }}
    </glxy-alert>
  } @else {
    <div>
      @if (functionCompleteURL) {
        <div class="header-with-button">
          <h3>{{ 'INBOX.CITATIONS.FUNCTION.REQUEST_URL' | translate }}</h3>
          <button mat-button color="primary" (click)="copyCurlCommand()">
            <mat-icon class="copy-icon">content_copy</mat-icon>
            {{ 'INBOX.CITATIONS.FUNCTION.COPY_AS_CURL' | translate }}
          </button>
        </div>
        <pre><code>{{ functionCompleteURL }}</code></pre>
      }

      @if (functionRequestBodyArgs) {
        <h3>{{ 'INBOX.CITATIONS.FUNCTION.REQUEST_PARAMETERS' | translate }}</h3>
        <pre><code>{{ functionRequestBodyArgs | json }}</code></pre>
      }

      @if (hasHeaders) {
        <h3>{{ 'INBOX.CITATIONS.FUNCTION.HEADERS' | translate }}</h3>
        <pre><code>{{ functionHeaders | json }}</code></pre>
      }
    </div>
    <div>
      <h3>{{ 'INBOX.CITATIONS.FUNCTION.RESPONSE' | translate }}</h3>
      @if (contentTruncated) {
        <glxy-alert type="warning">
          {{ 'INBOX.CITATIONS.FUNCTION.RESPONSE_TOO_LARGE' | translate: { maxKilobytes: contentOriginalSizeKb } }}
        </glxy-alert>
      }
      <pre>{{ content | json }}</pre>
    </div>
  }
</mat-dialog-content>
